module.exports = __webpack_public_path__ + "img/14-800x800.130d5fba.jpg";